const moment = require('moment');

export function calculateAge(birthDateStr) {
    const birthDate = moment(birthDateStr, 'YYYY-MM-DD');
    const now = moment();

    if (!birthDate.isValid()) {
        return 'Invalid date format. Use YYYY-MM-DD.';
    }

    const years = now.diff(birthDate, 'years');
    birthDate.add(years, 'years');

    const months = now.diff(birthDate, 'months');
    birthDate.add(months, 'months');

    const days = now.diff(birthDate, 'days');

    return `${years} ឆ្នាំ`;
}
